import { render, staticRenderFns } from "./SmsSendRecord.vue?vue&type=template&id=58d06190&scoped=true"
import script from "./SmsSendRecord.vue?vue&type=script&lang=js"
export * from "./SmsSendRecord.vue?vue&type=script&lang=js"
import style0 from "./SmsSendRecord.vue?vue&type=style&index=0&id=58d06190&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d06190",
  null
  
)

export default component.exports